import { WORKSPACE_TARGET_MIN_HEIGHT } from './targetSizes';

/**
 * A `ToggleButtonGroup` of a few short options, in the view bar's look: paper
 * segments, the one in force washed cobalt.
 */
export const segmentedSx = {
  display: 'flex',
  width: '100%',
  '& .MuiToggleButton-root': {
    flex: 1,
    minHeight: WORKSPACE_TARGET_MIN_HEIGHT,
    px: '8px',
    border: '1px solid var(--border)',
    backgroundColor: 'var(--paper)',
    color: 'var(--ink-muted)',
    font: 'inherit',
    fontSize: 13,
    fontWeight: 700,
    letterSpacing: '-0.01em',
    textTransform: 'none',
    whiteSpace: 'nowrap',
    transition:
      'background-color 200ms var(--ease-default, ease-out), border-color 200ms var(--ease-default, ease-out), color 200ms var(--ease-default, ease-out)',
    '@media (prefers-reduced-motion: reduce)': { transition: 'none' },
  },
  '& .MuiToggleButton-root.Mui-selected': {
    backgroundColor: 'color-mix(in srgb, var(--cobalt) 10%, var(--paper))',
    borderColor: 'var(--cobalt)',
    color: 'var(--ink)',
    // MUI overlaps neighbours by 1px; the one in force paints on top so its
    // cobalt edge wins the seam.
    position: 'relative',
    zIndex: 1,
  },
  '& .MuiToggleButton-root.Mui-selected:hover': {
    backgroundColor: 'color-mix(in srgb, var(--cobalt) 14%, var(--paper))',
  },
  '& .MuiToggleButton-root:not(.Mui-selected):hover': {
    backgroundColor: 'var(--bg-alt)',
  },
} as const;
